import { Boot } from "./src/Boot";

export const wrapRootElement = Boot;
